
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Mumbaitobanglorecabs() {



    const cardData =
    {
        keyword: ' Mumbai to Bangalore Cab Service ',
        heading: 'Vedant Travels: Mumbai to Bangalore Cab Service',
        headingDescription: 'Vedant Travels offers a comfortable and reliable Mumbai to Bangalore cab service, ensuring a smooth and hassle-free journey. Whether you are traveling for business, visiting IT hubs, or exploring Bangalore’s vibrant culture, our well-maintained fleet of sedans, SUVs, and luxury cars caters to all travel needs. Our experienced drivers ensure safety and convenience, with flexible pickup and drop-off options. With 24/7 availability, competitive fares, and an easy online booking system, Vedant Travels makes your Mumbai to Bangalore travel seamless and enjoyable.',

        top: 'Top Places to Visit in Bangalore with Vedant Travels',

"topPlaces": [
    {
        "title": "Lalbagh Botanical Garden",
        "description": "One of the most famous gardens in India, Lalbagh Botanical Garden features a stunning glasshouse inspired by the Crystal Palace in London. Spread across 240 acres, it houses rare plants, centuries-old trees, and scenic lakes, making it a paradise for nature lovers."
    },
    {
        "title": "Bangalore Palace",
        "description": "Built in Tudor-style architecture, Bangalore Palace is a must-visit landmark that reflects the grandeur of the Wodeyar dynasty. With wooden interiors, exquisite paintings, and vast courtyards, the palace offers a glimpse into Bangalore’s royal past."
    },
    {
        "title": "Cubbon Park",
        "description": "A green oasis in the heart of the city, Cubbon Park is spread over 300 acres, offering lush greenery, walking trails, and peaceful surroundings. The park is home to iconic landmarks like Attara Kacheri (High Court) and Seshadri Iyer Memorial Library."
    },
    {
        "title": "ISKCON Temple",
        "description": "The ISKCON Temple in Bangalore is one of the largest Hare Krishna temples in the world. With its grand architecture, spiritual atmosphere, and engaging devotional programs, it is a must-visit for devotees and tourists alike."
    },
    {
        "title": "Bannerghatta National Park",
        "description": "A perfect destination for wildlife lovers, Bannerghatta National Park offers an exciting safari experience, where you can spot tigers, lions, elephants, and other exotic animals in their natural habitat. The park also has a butterfly park and a zoo."
    },
    {
        "title": "MG Road & Brigade Road",
        "description": "For shopping and nightlife, MG Road and Brigade Road are Bangalore’s most vibrant spots. From branded stores and street shopping to cafes, pubs, and restaurants, these streets offer the perfect blend of modern and traditional Bangalore."
    },
    {
        "title": "Nandi Hills",
        "description": "Located about 60 km from Bangalore, Nandi Hills is a picturesque hill station perfect for a weekend getaway. With breathtaking sunrise views, Tipu Sultan’s Summer Palace, and trekking trails, it is a favorite spot for nature lovers and adventure seekers."
    },
    {
        "title": "Ulsoor Lake",
        "description": "One of Bangalore’s largest lakes, Ulsoor Lake is a great place for boating and picnics. Surrounded by lush greenery, it offers a serene escape from the city's hustle and bustle."
    },
    {
        "title": "Innovative Film City",
        "description": "A fun-filled attraction near Bangalore, Innovative Film City features movie sets, adventure sports, wax museums, and a water park. It is a perfect destination for families and thrill-seekers."
    },
    {
        "title": "Visvesvaraya Industrial & Technological Museum",
        "description": "Ideal for science enthusiasts, this interactive museum showcases exhibits on space, robotics, mechanics, and aviation. It is an exciting place for both kids and adults to explore the wonders of science and technology."
    }
],

"services": [
    {
      "name": "Mumbai to Bangalore Cab Service by Vedant Travels",
      "description": "Traveling from Mumbai to Bangalore? Vedant Travels offers reliable and comfortable cab services to make your journey smooth and hassle-free. Whether you're visiting for business, leisure, or a special event, our fleet of well-maintained vehicles ensures you a pleasant experience."
    },
    {
      "name": "Mumbai to Bangalore Taxi",
      "description": "Book a taxi from Mumbai to Bangalore with Vedant Travels for a seamless travel experience. Our professional drivers and comfortable vehicles will ensure you reach Bangalore safely and on time, whether you're traveling solo or with a group."
    },
    {
      "name": "Mumbai to Bangalore One Way Cab",
      "description": "For a one-way trip from Mumbai to Bangalore, Vedant Travels offers affordable and convenient taxi services. Our one-way cab service is perfect for those who need to travel to Bangalore without worrying about the return trip."
    },
    {
      "name": "Bangalore Cab Service",
      "description": "If you're in Bangalore and looking for a reliable taxi service, Vedant Travels has you covered. We offer dependable cab services within the city, making it easy to get around and explore all the wonderful sights and attractions."
    },
    {
      "name": "Mumbai to Bangalore Car Rental",
      "description": "Rent a car from Mumbai to Bangalore with Vedant Travels for a personalized and flexible travel experience. Our car rental service gives you the freedom to travel at your own pace, with a variety of vehicles to choose from based on your preferences."
    },
    {
      "name": "Mumbai to Bangalore Taxi Fare",
      "description": "At Vedant Travels, we offer transparent and competitive taxi fares for your journey from Mumbai to Bangalore. Our pricing is fair and affordable, ensuring you get value for your money while enjoying a comfortable trip. Contact us for an accurate fare quote."
    },
    {
      "name": "Mumbai to Bangalore Round Trip",
      "description": "Planning a round trip from Mumbai to Bangalore? Vedant Travels provides flexible round-trip taxi services, ensuring you enjoy a comfortable and reliable ride both ways. Our experienced drivers will ensure a smooth journey from start to finish."
    },
    {
      "name": "Mumbai to Bangalore Innova",
      "description": "Traveling with family or a group? Book an Innova for your Mumbai to Bangalore journey. The Innova is spacious and comfortable, making it the ideal choice for a long-distance trip. Enjoy the comfort and convenience of traveling in a premium vehicle."
    },
    {
      "name": "Bangalore Cab Booking from Mumbai",
      "description": "Booking a cab from Mumbai to Bangalore is easy with Vedant Travels. Whether you’re traveling for business, leisure, or any other reason, we provide a hassle-free booking process online or by phone, ensuring you have a reliable ride at your convenience."
    }
  ],



  "tableData": [
    ["Mumbai to Bangalore Cab", "Mumbai to Bangalore Taxi"],
    ["Mumbai to Bangalore One Way Cab", "Bangalore Cab Service"],
    ["Mumbai to Bangalore Car Rental", "Mumbai to Bangalore Taxi Fare"],
    ["Mumbai to Bangalore Round Trip", "Mumbai to Bangalore Innova"],
    ["Bangalore Cab Booking from Mumbai"]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we understand the importance of punctuality. Our professional drivers ensure timely pickups and drop-offs for your Mumbai to Bangalore trip, ensuring a smooth and stress-free journey from start to finish."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "Our fleet of well-maintained vehicles offers a comfortable and enjoyable ride. With ample legroom, air conditioning, and comfortable seating, our cars are designed to make your long-distance journey as relaxing as possible."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our skilled and experienced drivers are trained to handle long-distance routes like Mumbai to Bangalore. They ensure a safe, smooth, and timely ride while providing the best route options for a pleasant experience."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "We offer competitive pricing with no hidden charges. Our transparent pricing ensures you know exactly what you’ll pay upfront, so you get the best value for your money without any surprises."
    },
    {
      "WhyChooseheading": "Safe and Secure Journey",
      "WhyChoosedescription": "Safety is our priority. All our vehicles are regularly maintained and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers strictly adhere to safety guidelines to ensure a safe and secure journey."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether it's an early morning departure or a late-night return, Vedant Travels is available around the clock. Our customer service team is always ready to assist you at any time, ensuring a seamless experience throughout your trip."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking your Mumbai to Bangalore cab is easy and convenient. You can book online through our website or mobile app, or you can contact our customer service team for assistance with your booking."
    },
    {
      "WhyChooseheading": "Customized Travel Packages",
      "WhyChoosedescription": "We offer flexible travel packages that can be customized based on your specific needs. Whether you're traveling for business, leisure, or sightseeing, we tailor your journey to fit your schedule and preferences."
    }
  ]
    }
    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai to Bangalore cab with Vedant Travels?',
            answer: 'You can book your cab online through our website or mobile app. Alternatively, you can contact our customer service team to assist you with your booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the Mumbai to Bangalore trip?',
            answer: 'We offer a wide range of well-maintained vehicles, including sedans, SUVs, and luxury cars. All vehicles are designed for comfort and safety, ensuring a pleasant and smooth journey.',
        },
        {
            id: 3,
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, our drivers are highly experienced and familiar with long-distance routes. They are well-trained to provide a safe, smooth, and timely ride from Mumbai to Bangalore.',
        },
        {
            id: 4,
            question: 'How do I pay for my Mumbai to Bangalore cab rental?',
            answer: 'We accept various payment methods, including cash, credit/debit cards, and online payments via our app, making payment simple and convenient.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab for Mumbai to Bangalore?',
            answer: 'Yes, you can book a round-trip cab. Simply provide your return details during the booking process, and we’ll take care of the rest.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours during the Mumbai to Bangalore trip?',
            answer: 'Any additional charges for waiting time or detours will be communicated upfront. We believe in complete transparency, so there are no hidden costs.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Bangalore?',
            answer: 'Yes, we offer sightseeing tours in Bangalore. Explore popular attractions like Lalbagh Botanical Garden, Bangalore Palace, Cubbon Park, and more with a trusted driver.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Mumbai to Bangalore cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have additional or specialized luggage, please let us know at the time of booking, and we’ll make the necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel to Bangalore?',
            answer: 'Yes, we provide corporate travel services for business trips to Bangalore. Whether it’s for meetings, conferences, or corporate events, we ensure your travel is comfortable and punctual.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for Mumbai to Bangalore travel?',
            answer: 'Vedant Travels offers reliable, comfortable, and affordable cab services for your Mumbai to Bangalore trip. With experienced drivers, well-maintained vehicles, and transparent pricing, we ensure a safe, smooth, and hassle-free journey.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Rohit Deshmukh",
            title: "Customer",
            quote: "I traveled from Mumbai to Bangalore with Vedant Travels, and it was an excellent experience. The car was comfortable, the driver was professional, and I reached my destination on time. I highly recommend their services for long-distance travel!",
            rating: 5,
        },
        {
            name: "Mrs. Nisha Reddy",
            title: "Customer",
            quote: "Our family trip from Mumbai to Bangalore with Vedant Travels was fantastic. The vehicle was spacious and well-maintained, and the driver was friendly and knowledgeable. We’ll definitely use their services for future trips.",
            rating: 5,
        },
    ];
    
    
    
    
    
    
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    
      

  
 const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Bangalore Cab",
  "image": "https://vedanttravels.in/assets/images/mumbai-to-bangalore-cab.jpg",
  "description": "Book Mumbai to Bangalore cab with Vedant Travels for a safe and comfortable journey. Choose from AC sedans, SUVs, and tempo travellers for one-way and round trips between these two metropolitan cities.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "10999",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/mumbai-to-bangalore-cab"
  }
};


      


    return (
        <div>
           <Helmet>
  <title>Mumbai to Bangalore Cab | Comfortable & Reliable | Vedant Travels</title>
  <meta 
    name="description" 
    content="Book Mumbai to Bangalore cab with Vedant Travels for a safe and comfortable journey. Choose from AC sedans, SUVs, and tempo travellers for one-way and round trips between these two metropolitan cities." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Bangalore Cab, Bangalore Taxi from Mumbai, Vedant Travels Mumbai Bangalore, AC Cab Mumbai Bangalore, SUV Cab Mumbai Bangalore, Outstation Cab Mumbai Bangalore" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

           
            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/95.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitobanglorecabs;